import type { StickerIllustrationProps } from '../Sticker';

export const PhoneStickerIllustration = ({ size }: StickerIllustrationProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="30.4915"
      width="76.5165"
      height="62.1697"
      rx="26.1669"
      transform="rotate(-15 0 30.4915)"
      fill="#D9EFD4"
      stroke="white"
      strokeWidth="5.625"
    />
    <path
      d="M31.2902 35.2582C32.1626 35.0245 33.0853 35.2526 33.7004 35.8543L37.9673 40.0281C38.5259 40.5745 38.7546 41.3553 38.5782 42.1148L37.17 48.1795C37.17 48.1795 39.0493 51.9127 43.3438 54.2108C47.6385 56.5089 52.0432 56.1385 52.0432 56.1385L56.9916 51.9694C57.6118 51.4468 58.455 51.2393 59.2449 51.4149L65.2927 52.7589C66.1613 52.9519 66.8356 53.5785 67.0546 54.3958L68.585 60.1073C69.3643 63.0158 67.0454 65.8887 63.8567 65.7464C57.3075 65.4543 46.9613 64.3291 39.5291 60.3519C32.0969 56.3747 25.8639 48.628 22.3101 43.5138C20.5798 41.0237 22.0966 37.7216 25.199 36.8904L31.2902 35.2582Z"
      fill="#69C055"
    />
    <path
      d="M24.0466 5.0625L23.8788 8.59341"
      stroke="white"
      strokeWidth="5.625"
      strokeLinecap="round"
    />
    <path
      d="M14.0625 5.0625L16.875 10.6875"
      stroke="white"
      strokeWidth="5.625"
      strokeLinecap="round"
    />
    <path
      d="M8.4375 13.3759L10.7828 16.0207"
      stroke="white"
      strokeWidth="5.625"
      strokeLinecap="round"
    />
  </svg>
);
